import { inject } from "@angular/core";
import { SETTING_SIDENAV_LINKS } from "@app/applications/settings/config/side-nav-links.config";
import { AUTHENTICATION_SIDENAV_LINKS } from "@app/applications/authentication/config/side-nav-links.config";
import { USERS_SIDENAV_LINKS } from "@app/applications/users/config/side-nav-links.config";
import { COMPANY_HIERARCHY_SIDENAV_LINKS } from "@app/applications/company-hierarchy/config/side-nav-links.config";
import { ADD_MAIN_LINKS } from "../../layouts/config/sidenav.config";
import { ASSETS_SIDENAV_LINKS } from "@app/applications/assets/config/side-nav-links.config";
import { CRM_SIDENAV_LINKS } from "@app/applications/crm/config/side-nav-links.config";
import { DYNAMIC_FORMS_SIDENAV_LINK } from "@app/applications/dynamic-form/config/side-nav-links.config";
import { GEO_DATA_SIDENAV_LINK } from "@app/applications/geo-data/domains/countries/configs/side-nav-links.config";
import { FLEET_SIDENAV_LINKS } from "@app/applications/fleet/config/side-nav-links.config";
import { MOVEMENTS_MANAGEMENT_SIDENAV_LINKS } from "@app/applications/movements-management/config/side-nav-links.config";
import { REVENUE_MANAGEMENT_SIDENAV_LINKS } from "@app/applications/revenue-management/config/side-nav-links.config";

export function provideSideNav() {
  inject(ADD_MAIN_LINKS);
  inject(SETTING_SIDENAV_LINKS);
  inject(AUTHENTICATION_SIDENAV_LINKS);
  inject(COMPANY_HIERARCHY_SIDENAV_LINKS);
  inject(USERS_SIDENAV_LINKS);
  inject(ASSETS_SIDENAV_LINKS);
  inject(CRM_SIDENAV_LINKS);
  inject(DYNAMIC_FORMS_SIDENAV_LINK);
  inject(GEO_DATA_SIDENAV_LINK);
  inject(FLEET_SIDENAV_LINKS);
  inject(MOVEMENTS_MANAGEMENT_SIDENAV_LINKS);
  inject(REVENUE_MANAGEMENT_SIDENAV_LINKS);
}
